import { Component, OnInit, Output, Input, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {  Choice, FilterDefinition } from '@model';
import { RegisterFilter } from '@core/filter.registry';
import { BaseFilterComponent } from '@core/components/base-filter/base-filter.component';

@RegisterFilter
@Component({
    selector: 'app-multi-choice-filter-pane',
    templateUrl: './multi-choice-filter-pane.component.html',
    standalone: false
})
export class MultiChoiceFilterPaneComponent extends BaseFilterComponent implements OnInit, OnChanges {
  @Output()
  value: Array<string>;

  @Output()
  valueChanged = new EventEmitter<FilterDefinition>();

  @Input()
  filter: FilterDefinition;

  @ViewChild('menuButton', { static: true })
  menuTrigger: MatMenuTrigger;

  componentName = 'MultiChoiceFilterPaneComponent';

  selections: Choice[] = [];

  _label: string;
  isChanged: boolean;
  showSelected = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.filter && this.filter.multiChoiceFilter && this.filter.multiChoiceFilter.selections) {
      this.selections = this.filter.multiChoiceFilter.selections;
      this.setSelected(this.filter.selected, this.selections);
    }
    this.isChanged = this.filter.selected && this.filter.selected.length > 0 ? true : false;
    this.setLabel(this.isChanged);
  }

  ngOnChanges() {
    if (this.filter && this.filter.multiChoiceFilter && this.filter.multiChoiceFilter.selections) {
      this.selections = this.filter.multiChoiceFilter.selections;
      this.setSelected(this.filter.selected, this.selections);
    }
    this.isChanged = this.filter.selected && this.filter.selected.length > 0 ? true : false;
    this.setLabel(this.isChanged);
  }

  setLabel(_isChanged: boolean) {
    this.value = this.selections.filter(s => s.selected).map(o => o.name);
    if (this.value?.length > 0) {
      this.showSelected = true;
    }
  }

  // selected contains list of names
  setSelected(_selected: string[], _selections: Choice[]) {
    let tmpSelections: Choice[] = [];
    if (_selected && _selected.length > 0) {
      _selections.forEach(o => {
        if (_selected.includes(o.name)) {
          let choice = {
            name: o.name,
            value: o.value,
            selected: true
          } as Choice;
          tmpSelections.push(choice);
        } else {
          let choice = {
            name: o.name,
            value: o.value,
            selected: false
          } as Choice;
          tmpSelections.push(choice);
        }
      });
      this.selections = tmpSelections;
    }
  }

  panelOpened(showSelected: boolean) {
    this.showSelected = false;
  }

  panelClosed(showSelected: boolean) {
    this.showSelected = true;
  }

  updateFilter = event => {
    this.value = this.selections.filter(s => s.selected).map(o => o.name);
    this.filter.multiChoiceFilter.selected = this.value;
    this.filter.selected = this.value;
    this.valueChanged.emit(this.filter);
  };
}
